<template>
  <b-table
    :data="data"
    :loading="isLoading"
    paginated
    backend-pagination
    :total="total"
    :per-page="perPage"
    @page-change="onPageChange"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
  >
    <template slot-scope="props">
      <b-table-column field="active" label="Ativo" numeric>
        <b-icon
          v-if="props.row.active"
          size="is-small"
          icon="check"
          type="is-success"
        ></b-icon>
        <b-icon v-else size="is-small" icon="close" type="is-danger"></b-icon>
      </b-table-column>

      <b-table-column label="Data e Hora">{{
        props.row.datetime | date('DD/MM/YYYY [às] HH:mm')
      }}</b-table-column>

      <b-table-column label="Título">{{ props.row.title }}</b-table-column>

      <b-table-column label="Opções">
        <router-link
          :to="`${props.row.id}/edit`"
          tag="button"
          type="button"
          v-tooltip.bottom="'Editar'"
          v-app-button.icon-only
        >
          <b-icon size="is-small" icon="pencil"></b-icon>
        </router-link>
        <button
          @click="onClickDeleteInformative(props.row.id)"
          v-app-button.icon-only
          color="danger"
          v-tooltip.bottom="'Excluir'"
        >
          <b-icon size="is-small" icon="delete"></b-icon>
        </button>
      </b-table-column>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import InformativeService from '@/services/informative.service';

export default {
  name: 'informatives-table',
  data: () => {
    return {
      data: [],
      total: 0,
      isLoading: true,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      InformativeService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastify('Erro ao carregar Notícias.', 'error'))
        .finally(() => (this.isLoading = false));
    },
    onClickDeleteInformative(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Notícia',
        message:
          'Tem certeza que deseja <b>excluir</b> esta notícia? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir Notícia',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteInformative(id),
      });
    },
    deleteInformative(id) {
      InformativeService.delete(id)
        .then(() => {
          this.toastify('Notícia excluída com sucesso.');
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Notícia.',
            'error'
          );
        });
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>
